import React, { useState, useEffect } from "react";
import { Button, Input, Form, message, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { validatePasscode } from "../../../api/UserAPI";

const { Title } = Typography;

const SendMoneyConfirm = ({ data, onBack, onConfirm }) => {
  const [passcode, setPasscode] = useState(["", "", "", ""]);
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(false);

  // Helper: Join passcode array
  const joinedPasscode = passcode.join("");

  // Validate passcode when 4 digits entered
  useEffect(() => {
    if (joinedPasscode.length === 4) {
      setLoading(true);
      validatePasscode({ pinNo: joinedPasscode })
        .then((res) => {
          setLoading(false);
          if (res.data && res.data.status === 1) {
            setIsValid(true);
            message.success("Passcode valid");
          } else {
            setIsValid(false);
            message.error(res.data.message || "Invalid passcode");
          }
        })
        .catch(() => {
          setLoading(false);
          setIsValid(false);
          message.error("Error validating passcode");
        });
    } else {
      setIsValid(false);
    }
  }, [joinedPasscode]);

  const handleChange = (index, e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) {
      const newPasscode = [...passcode];
      newPasscode[index] = val.slice(-1);
      setPasscode(newPasscode);

      // Auto-focus next input
      if (val && index < 3) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleConfirm = () => {
    if (isValid) {
      onConfirm(joinedPasscode);
    } else {
      message.error("Please enter a valid passcode");
    }
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "0 auto",
        minHeight: "100vh",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        padding: "0 24px",
        boxSizing: "border-box",
        position: "relative",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", paddingTop: 24 }}>
        <LeftOutlined
          style={{ fontSize: 20, marginRight: 4, cursor: "pointer" }}
          onClick={onBack}
        />
        <Title
          style={{
            flex: 1,
            textAlign: "center",
            fontWeight: "700",
            color: "#2e3a59",
            margin: 0,
          }}
        >
          Send money
        </Title>
      </div>

      {/* Details */}
      <div style={{ marginTop: 38 }}>
        <DetailItem label="Money to" value={data.to} />
        <DetailItem label="Money from" value={data.from} />
        <DetailItem label="Expense category" value={data.category} />
        <DetailItem label="Amount" value={data.amount} />
        <DetailItem label="Fee" value={data.fee} />
      </div>

      {/* OTP Inputs */}
      <div style={{ display: "flex", justifyContent: "center", gap: 12, marginBottom: 40 }}>
        {[0, 1, 2, 3].map((_, index) => (
          <Input
            key={index}
            id={`otp-input-${index}`}
            maxLength={1}
            value={passcode[index]}
            onChange={(e) => handleChange(index, e)}
            style={{
              width: 50,
              height: 50,
              fontSize: 24,
              textAlign: "center",
              borderRadius: 8,
              borderColor: isValid ? "#52c41a" : undefined,
            }}
            type="tel"
            pattern="\d*"
            autoComplete="off"
            inputMode="numeric"
          />
        ))}
      </div>

      {/* Confirm Button */}
      <Button
        type="primary"
        block
        style={{
          background: isValid
            ? "linear-gradient(90deg,#021b79,#0575E6)"
            : "#ccc",
          border: "none",
          borderRadius: "18px",
          color: "#fff",
          fontWeight: 700,
          fontSize: 18,
          height: 50,
        }}
        disabled={!isValid || loading}
        onClick={handleConfirm}
        loading={loading}
      >
        Confirm
      </Button>
    </div>
  );
};

const DetailItem = ({ label, value }) => (
  <div style={{ marginBottom: 26 }}>
    <div style={{ color: "#8493ad", fontWeight: 500, fontSize: 14 }}>{label}</div>
    <div style={{ color: "#22314a", fontWeight: 600, fontSize: 16 }}>{value}</div>
  </div>
);

export default SendMoneyConfirm;
